import { Grid } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import styles from './StatGrid.module.scss'

function HairlineDivider() {
  return <hr className={styles['divider']} />
}

function StatGrid({ grid }) {
  const isMobile = useViewportSmallerThan(BREAKPOINTS.lg)
  grid = grid?.gridItemsCollection?.items
  for (let i = 0; i < 4; i++) {
    if (!grid?.[i]) return null
  }

  let gridBox = []

  for (let i = 0; i < grid.length; i++) {
    if (grid[i]?.fieldName === 'title') {
      gridBox.push(
        <Grid data-testid={`stat-grid-item-${i}`}>
          <Typography
            variant="labelMd"
            fontWeight="regular"
            content={grid[i]?.textContent}
            data-testid="video-title"
          />
          <Typography
            className={styles['blue-text']}
            variant={'bodyLg'}
            content={grid[i + 1]?.textContent}
            fontWeight="medium"
            data-testid="video-stat"
          />
        </Grid>
      )
    }
  }

  return (
    <>
      {isMobile ? (
        <Grid container className={styles['stat-grid-container']}>
          <Grid container className={styles['stat-grid-sub-grid']}>
            <Grid container item className={styles['stat-grid-element']}>
              {gridBox[0] && <Grid>{gridBox[0]}</Grid>}
              {gridBox[1] && <Grid>{gridBox[1]}</Grid>}
            </Grid>
            <HairlineDivider />
            <Grid container item className={styles['stat-grid-element']}>
              {gridBox[2] && <Grid>{gridBox[2]}</Grid>}
              {gridBox[3] && <Grid>{gridBox[3]}</Grid>}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container className={styles['subtitle']}>
          <HairlineDivider />
          <Grid container className={styles['stat-grid-element']} data-testid="stat-grid-container">
            {gridBox[0] && <Grid>{gridBox[0]}</Grid>}
            {gridBox[1] && <Grid>{gridBox[1]}</Grid>}
            {gridBox[2] && <Grid>{gridBox[2]}</Grid>}
            {gridBox[3] && <Grid>{gridBox[3]}</Grid>}
          </Grid>
        </Grid>
      )}
    </>
  )
}

export { StatGrid }
